




































export default {
  data () {
    return {
      question: null,
      id: this.$route.params.id,
    }
  },

  mounted () {
    this.loadContent()
  },

  methods: {
    async loadContent () {
      const { data } = await this.$axios.get(`misc/${this.id}`)
      this.question = data
    },
  },
}
